import { Text } from '@airwallex/typography';
import React from 'react';
import { formatMoney } from '@/utils/formatPayment';
import { VStack } from '@airwallex/stacks';
import { useTranslation } from 'react-i18next';
import { buildDiscountLabel } from '@/utils/discount';
import { DiscountInfo } from '@/types/discount';
import { cellContainerStyle } from './style';

interface DiscountCellProps {
  discount: DiscountInfo;
  variant?: 'label' | 'amount';
  currency?: string;
  useVStack?: boolean;
  align?: 'LEFT' | 'RIGHT';
}

const DiscountCell: React.FC<DiscountCellProps> = ({
  discount,
  variant = 'label',
  currency,
  useVStack = true,
  align = 'LEFT',
}) => {
  const { t } = useTranslation();
  const discountNameText = `↳ ${buildDiscountLabel(discount, t)}`;
  const content =
    variant === 'amount' && currency ? (
      <Text variant="body">{`-${formatMoney(discount.amount, currency)}`}</Text>
    ) : (
      <Text variant="body" color="secondary" title={discountNameText}>
        {discountNameText}
      </Text>
    );

  const commonProps = {
    'data-row-type': 'discount' as const,
  };

  if (useVStack) {
    return (
      <VStack align={align} style={cellContainerStyle} {...commonProps}>
        {content}
      </VStack>
    );
  }

  return (
    <div style={cellContainerStyle} {...commonProps}>
      {content}
    </div>
  );
};

export default DiscountCell;
